(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-validate-manual/assets/javascript/pages/home/page.js') >= 0) return;  svs.modules.push('/modules/tickets-validate-manual/assets/javascript/pages/home/page.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }

const PageWrapper = svs.ticketsValidateManual.components.PageWrapper;
const _svs$ticketsValidateM = svs.ticketsValidateManual.pages.home.components,
  Info = _svs$ticketsValidateM.Info,
  InfoMobile = _svs$ticketsValidateM.InfoMobile,
  PhysicalInfo = _svs$ticketsValidateM.PhysicalInfo,
  DividedCodeInput = _svs$ticketsValidateM.DividedCodeInput,
  InstructionsInfo = _svs$ticketsValidateM.InstructionsInfo,
  TrackQRCodeFailure = _svs$ticketsValidateM.TrackQRCodeFailure;
const QrScanner = svs.tur.qrScanner.QrScanner;
const validateQrCode = url => {
  const _ReactRouterDOM = ReactRouterDOM,
    matchPath = _ReactRouterDOM.matchPath;
  const qrUrl = new URL(url);
  const match = matchPath(qrUrl === null || qrUrl === void 0 ? void 0 : qrUrl.pathname, {
    path: '/rl/:ticketId'
  });
  if (!match) {
    throw new Error('Invalid QR code');
  }
  svs.ticketgames.ticketMappings.productMappings.getProductByTicketId(match.params.ticketId);
};
const Page = _ref => {
  let match = _ref.match;
  const _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    showQrScanner = _React$useState2[0],
    setShowQrScanner = _React$useState2[1];
  const isMobile = svs.core.detect.formfactor.mobile();
  if (showQrScanner) {
    return React.createElement(QrScanner, {
      onClose: () => setShowQrScanner(false),
      validateQrCode: validateQrCode
    });
  }
  return React.createElement(PageWrapper, null, React.createElement(TrackQRCodeFailure, {
    ticketId: match.params.ticketId
  }), isMobile ? React.createElement(InfoMobile, {
    onScanQrClick: () => setShowQrScanner(true)
  }) : React.createElement(Info, null), React.createElement(DividedCodeInput, {
    ticketId: match.params.ticketId
  }), React.createElement(PhysicalInfo, null), React.createElement(InstructionsInfo, null));
};
setGlobal('svs.ticketsValidateManual.pages.Home', Page);

 })(window);